import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showInitiativesDropdown, setShowInitiativesDropdown] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowInitiativesDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleHomeClick = () => {
    setIsMenuOpen(false);
    setShowInitiativesDropdown(false);

    // Force fresh landing page load
    window.location.replace(
      `${window.location.origin}/?v=${Date.now()}`
    );
  };

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm">
      <div className="container relative mx-auto px-4 py-3">

        {/* Main Header Row */}
        <div className="flex w-full items-center justify-between">

          {/* Logos */}
          <div className="flex flex-shrink-0 items-center">
            <div className="flex items-center space-x-1 sm:space-x-2">

              <img
                src="/images/dept.png"
                alt="Logo 1"
                className="h-6 w-auto sm:h-7"
              />

              <img
                src="/images/tnlogo.png"
                alt="Logo 2"
                className="hidden h-6 w-auto sm:block sm:h-7"
              />

              <img
                src="/images/dept1.png"
                alt="Logo 3"
                className="hidden h-6 w-auto sm:block sm:h-7"
              />

              <img
                src="/images/india.png"
                alt="Logo 4"
                className="h-6 w-auto sm:h-7"
              />

            </div>
          </div>

          {/* Title */}
          <div className="mx-4 hidden flex-grow text-center sm:block md:mx-6">
            <h1 className="text-xs font-semibold leading-tight text-gray-800 md:text-sm">
              Commissionerate of Rural Development and Panchayat Raj
              (Training)
            </h1>
          </div>

          {/* Mobile Menu Button */}
          <div className="flex items-center md:hidden">
            <button
              type="button"
              onClick={toggleMenu}
              className="text-gray-600 hover:text-blue-600 focus:outline-none"
              aria-label="Toggle mobile menu"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="ml-auto hidden items-center md:flex">
            <div className="flex items-center space-x-2 xl:space-x-3">

              {/* HOME */}
              <button
                type="button"
                onClick={handleHomeClick}
                className="flex items-center px-2 py-1 text-gray-700 transition-colors hover:text-blue-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-1 h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  />
                </svg>

                <span className="text-xs font-medium">
                  Home
                </span>
              </button>

              {/* ABOUT */}
              <Link
                to="/about"
                className="flex items-center px-2 py-1 text-gray-700 transition-colors hover:text-blue-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-1 h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>

                <span className="text-xs font-medium">
                  About Us
                </span>
              </Link>

              {/* DOCUMENTS */}
              <Link
                to="/documents"
                className="flex items-center px-2 py-1 text-gray-700 transition-colors hover:text-blue-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-1 h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>

                <span className="text-xs font-medium">
                  Documents
                </span>
              </Link>

              {/* INITIATIVES */}
              <div
                className="relative group"
                ref={dropdownRef}
              >
                <button
                  type="button"
                  className="flex items-center px-2 py-1 text-gray-700 transition-colors hover:text-blue-600 focus:outline-none"
                  onClick={() =>
                    setShowInitiativesDropdown((prev) => !prev)
                  }
                  onMouseEnter={() =>
                    setShowInitiativesDropdown(true)
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="mr-1 h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    />
                  </svg>

                  <span className="text-xs font-medium">
                    Initiatives
                  </span>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-1 h-3 w-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>

                {showInitiativesDropdown && (
                  <div
                    className="absolute left-0 z-50 mt-2 w-32 rounded-md border border-gray-100 bg-white py-1 shadow-lg"
                    onMouseLeave={() =>
                      setShowInitiativesDropdown(false)
                    }
                  >
                    <Link
                      to="/sird"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                      onClick={() =>
                        setShowInitiativesDropdown(false)
                      }
                    >
                      SIRD
                    </Link>

                    <Link
                      to="/rird"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                      onClick={() =>
                        setShowInitiativesDropdown(false)
                      }
                    >
                      RIRD
                    </Link>
                  </div>
                )}
              </div>

              {/* SCHEMES */}
              <Link
                to="/schemes"
                className="flex items-center px-2 py-1 text-gray-700 transition-colors hover:text-blue-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-1 h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                  />
                </svg>

                <span className="text-xs font-medium">
                  Schemes
                </span>
              </Link>

              {/* TRAINING */}
              <Link
                to="/training-modules"
                className="flex items-center whitespace-nowrap px-2 py-1 text-gray-700 transition-colors hover:text-blue-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-1 h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  />
                </svg>

                <span className="text-xs font-medium">
                  Training Modules
                </span>
              </Link>

              {/* LOGIN */}
              <Link
                to="/login"
                className="flex items-center px-2 py-1 text-gray-700 transition-colors hover:text-blue-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-1 h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                  />
                </svg>

                <span className="text-xs font-medium">
                  Login
                </span>
              </Link>

            </div>
          </nav>
        </div>

        {/* Mobile Title */}
        <div className="mt-2 text-center sm:hidden">
          <h2 className="text-xs font-semibold text-gray-800">
            Commissionerate of Rural Development and Panchayat Raj
            (Training)
          </h2>
        </div>

        {/* Mobile Menu */}
        <div
          className={`mt-3 border-t border-gray-100 pt-3 transition-all duration-300 md:hidden ${
            isMenuOpen
              ? 'max-h-[500px] opacity-100'
              : 'max-h-0 overflow-hidden opacity-0'
          }`}
        >
          <div className="flex flex-col space-y-2">

            {/* MOBILE HOME */}
            <button
              type="button"
              onClick={handleHomeClick}
              className="flex items-center px-2 py-2 text-left text-gray-700 transition-colors hover:text-blue-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="mr-3 h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>

              <span className="font-medium">
                Home
              </span>
            </button>

            <Link
              to="/about"
              className="flex items-center px-2 py-2 text-gray-700 transition-colors hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              <span className="font-medium">
                About Us
              </span>
            </Link>

            <Link
              to="/documents"
              className="flex items-center px-2 py-2 text-gray-700 transition-colors hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              <span className="font-medium">
                Documents
              </span>
            </Link>

            <div className="space-y-1">
              <div className="px-2 py-2 text-gray-700">
                <span className="font-medium">
                  Initiatives
                </span>
              </div>

              <div className="space-y-1 pl-10">
                <Link
                  to="/sird"
                  className="block py-1 text-gray-600 hover:text-blue-600"
                  onClick={() => setIsMenuOpen(false)}
                >
                  SIRD
                </Link>

                <Link
                  to="/rird"
                  className="block py-1 text-gray-600 hover:text-blue-600"
                  onClick={() => setIsMenuOpen(false)}
                >
                  RIRD
                </Link>
              </div>
            </div>

            <Link
              to="/schemes"
              className="flex items-center px-2 py-2 text-gray-700 transition-colors hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              <span className="font-medium">
                Schemes
              </span>
            </Link>

            <Link
              to="/training-modules"
              className="flex items-center px-2 py-2 text-gray-700 transition-colors hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              <span className="font-medium">
                Training Modules
              </span>
            </Link>

            <Link
              to="/login"
              className="flex items-center px-2 py-2 text-gray-700 transition-colors hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              <span className="font-medium">
                Login
              </span>
            </Link>

          </div>
        </div>

      </div>
    </header>
  );
};

export default Header;